import { GOOGLE_CHAT_OAUTH_CALLBACK_PATH } from '@streamliner/shared/types/googleChatAuthorization';

export type GoogleChatCallbackInput = { code?: string; state: string; error?: string };
let captured: GoogleChatCallbackInput | undefined;
let deferredBuildRefresh: (() => void) | undefined;

/** Keep the callback input in memory until completion, then leave its sanitized URL before reload. */
export const resumeGoogleChatBuildRefresh = (): void => {
  if (captured || window.location.pathname === GOOGLE_CHAT_OAUTH_CALLBACK_PATH) return;
  const refresh = deferredBuildRefresh;
  deferredBuildRefresh = undefined;
  refresh?.();
};

export const runAfterGoogleChatCallback = (refresh: () => void): void => {
  if (captured || window.location.pathname === GOOGLE_CHAT_OAUTH_CALLBACK_PATH) {
    deferredBuildRefresh = refresh;
    return;
  }
  refresh();
};

/** Run before private bootstrap/telemetry so OAuth codes never enter page-view URLs. */
export const captureGoogleChatOAuthCallback = (): void => {
  if (window.location.pathname !== GOOGLE_CHAT_OAUTH_CALLBACK_PATH) return;
  const query = new URLSearchParams(window.location.search);
  if (query.has('state'))
    captured = {
      state: query.get('state') ?? '',
      code: query.get('code') ?? undefined,
      error: query.get('error') ?? undefined,
    };
  window.history.replaceState(window.history.state, '', window.location.pathname);
};
export const googleChatCallbackInput = (): GoogleChatCallbackInput | undefined => captured;
export const clearGoogleChatCallbackInput = (): void => {
  captured = undefined;
  resumeGoogleChatBuildRefresh();
};
